import {ENDPOINT_URL} from '../constants/index';

import {apiErrorHandling} from '../utils/apiUtils';

import getFetchOptions from '../utils/getFetchOptions';

export default function createAuthToken(adminId, email) {
	return fetch(
		`${ENDPOINT_URL}/newtoken`,
		getFetchOptions({
			method: 'POST',
			body: JSON.stringify({adminId, email}),
		})
	)
		.then((response) => {
			if (!response.ok) {
				throw response;
			}
			return response.json();
		})
		.catch((err) => {
			return Promise.reject(apiErrorHandling(err));
		});
}
